// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__c-o2s","consentsList":"PatientConsents_consentsList__1ppDW","consentsListEmpty":"PatientConsents_consentsListEmpty__X7Gc0"};